import { execute, addQueryParams } from '@/api/utils'
import { GET, PUT, POST, DELETE } from '@/api/types'

export default {
  list (farmID, params = {}) {
    return execute(GET, addQueryParams(`farms/${farmID}/recipes`, params))
  },
  create (farmID, payload) {
    return execute(POST, `farms/${farmID}/recipes`, payload)
  },
  updateById (farmID, id, payload) {
    return execute(PUT, `farms/${farmID}/recipes/${id}`, payload)
  },
  getById (farmID, id) {
    return execute(GET, `farms/${farmID}/recipes/${id}`)
  },
  deleteById (farmID, id) {
    return execute(DELETE, `farms/${farmID}/recipes/${id}`)
  }
}
